import { render, staticRenderFns } from "./alertDetail.vue?vue&type=template&id=23b4f12a&scoped=true&"
import script from "./alertDetail.vue.js?vue&type=script&lang=js&"
export * from "./alertDetail.vue.js?vue&type=script&lang=js&"
import style0 from "./alertDetail.vue?vue&type=style&index=0&id=23b4f12a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4f12a",
  null
  
)

export default component.exports